import { useEffect } from "react";
import { useActiveStore } from "@/store/activePages";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Validation hook to change tab with validation
 * @param pageName name to keep on cache and validate when change route
 * @param navigateTo route to navigate when is an invalid tab
 */
export const useTabsValidation = (pageName: string, navigateTo: string) => {
  const navigate = useNavigate();
  const location = useLocation();
  const activePages = useActiveStore((store) => store.pages);

  useEffect(() => {
    if (!activePages.has(pageName)) {
      navigate(navigateTo.startsWith("/") ? navigateTo : `/${navigateTo}`);
    }
  }, [activePages, pageName, navigateTo, navigate, location]);
};

export default useTabsValidation;
